import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { subscribeToSuccessNotifications } from "@/services/successNotifications";
import "./SuccessNotifications.css";

interface SuccessNotification {
  id: number;
  message: string;
}

const NOTIFICATION_DURATION_MS = 5000;

// Notifications raised in the same millisecond must still get distinct ids, so
// the counter runs independently of the clock.
let lastNotificationId = 0;

export function SuccessNotifications() {
  const { t } = useTranslation();
  const [notifications, setNotifications] = useState<readonly SuccessNotification[]>([]);

  useEffect(() => subscribeToSuccessNotifications((message) => {
    lastNotificationId += 1;
    const id = lastNotificationId;
    setNotifications((current) => [...current, { id, message }]);
    window.setTimeout(() => {
      setNotifications((current) => current.filter((notification) => notification.id !== id));
    }, NOTIFICATION_DURATION_MS);
  }), []);

  return (
    <div
      className="success-notifications"
      aria-live="polite"
      aria-label={t("successNotifications.label")}
    >
      {notifications.map((notification) => (
        <div key={notification.id} className="success-notification" role="status">
          <span>{notification.message}</span>
          <button
            type="button"
            aria-label={t("successNotifications.dismiss")}
            onClick={() => setNotifications((current) => current.filter((item) => item.id !== notification.id))}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
